import type { RouteLocationNormalizedLoaded } from 'vue-router'

const BASE_TITLE = 'شركة المنارة المتقدمة'
const DEFAULT_DESCRIPTION = ''
const DEFAULT_IMAGE = 'https://dashboard.mm.sa/logo.svg'

type RouteMetaTitle = string | ((route: RouteLocationNormalizedLoaded) => string)

export type AppHead = {
  title: string
  description: string
  image: string
  url: string
}

const resolveRouteTitle = (route: RouteLocationNormalizedLoaded) => {
  const metaTitle = route.meta.title as RouteMetaTitle | undefined
  const titlePart = typeof metaTitle === 'function' ? metaTitle(route) : metaTitle

  return titlePart ? `${titlePart} - ${BASE_TITLE}` : BASE_TITLE
}

export const getHeadForRoute = (
  route: RouteLocationNormalizedLoaded,
  origin = 'https://dashboard.mm.sa'
): AppHead => ({
  title: resolveRouteTitle(route),
  description: DEFAULT_DESCRIPTION,
  image: new URL(`/og-image?url=${encodeURIComponent(route.fullPath || '/')}`, origin).toString(),
  url: new URL(route.fullPath || '/', origin).toString()
})

const upsertMeta = (selector: string, attributes: Record<string, string>) => {
  if (typeof document === 'undefined') return

  let element = document.head.querySelector<HTMLMetaElement>(selector)

  if (!element) {
    element = document.createElement('meta')
    document.head.appendChild(element)
  }

  for (const [key, value] of Object.entries(attributes)) {
    element.setAttribute(key, value)
  }
}

export const applyHead = (head: AppHead) => {
  if (typeof document === 'undefined') return

  document.title = head.title

  upsertMeta('meta[property="og:title"]', { property: 'og:title', content: head.title })
  upsertMeta('meta[property="og:description"]', {
    property: 'og:description',
    content: head.description
  })
  upsertMeta('meta[property="og:image"]', { property: 'og:image', content: head.image })
  upsertMeta('meta[property="og:url"]', { property: 'og:url', content: head.url })

  upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: head.title })
  upsertMeta('meta[name="twitter:description"]', {
    name: 'twitter:description',
    content: head.description
  })
  upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: head.image })
  upsertMeta('meta[property="twitter:url"]', { property: 'twitter:url', content: head.url })
}
